import { render, staticRenderFns } from "./unpaid-record.vue?vue&type=template&id=8dd0deac&scoped=true&"
import script from "./unpaid-record.vue?vue&type=script&lang=ts&"
export * from "./unpaid-record.vue?vue&type=script&lang=ts&"
import style0 from "./unpaid-record.vue?vue&type=style&index=0&id=8dd0deac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd0deac",
  null
  
)

export default component.exports